import { getPermissions } from "@/helper/collection";
import { authenticationService } from "@/services/AuthenticationService";

export const ReportsRoutes = {
  path: "reports",
  name: "Reports",
  redirect: "reports/reports-master",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/ReportsContainer/reportsMaster"),
      meta: {},
    },
    {
      path: "report-builder",
      name: "Report Builder",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/reportBuilderComponents/reportBuilderComponentsV2.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          230,
          2,
        ),
      },
    },
    {
      path: "report-builder-v1",
      name: "Report Builder V1",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/reportBuilderComponents/reportBuilderComponents.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          93,
          2,
        ),
      },
    },
    {
      path: "aggregator-report",
      name: "Aggregator Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/aggregatorSalesNewFormat.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          254,
          2,
        ),
      },
    },
    {
      path: "summary",
      name: "Summary",
      component: () => import("@/components/Pages/ReportsContainer/summary"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          93,
          1,
        ),
      },
    },
    {
      path: "loyalty-overview-report",
      name: "Loyalty Overview",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/LoyalityOverviewReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          280,
          2,
        ),
      },
    },
    {
      path: "loyalty-settlement-report",
      name: "Loyalty Settlements",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/LoyalitySettlementReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          281,
          2,
        ),
      },
    },
    {
      path: "summaryv2",
      name: "Reports Summary Version 2",
      component: () => import("@/components/Pages/ReportsContainer/summaryv2"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          93,
          1,
        ),
      },
    },
    {
      path: "cash-card-status",
      name: "Website Cash Card Status",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/CashCardComponents/onlineCashCardReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          234,
          1,
        ),
      },
    },
    {
      path: "occupancy",
      name: "Occupancy Reports",
      component: () =>
        import("@/components/Pages/ReportsContainer/occupancyReports"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          189,
          1,
        ),
      },
    },
    {
      path: "employee-offer-report",
      name: "Employee Offer Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/FnbCourtseyReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          341,
          1,
        ),
      },
    },
    {
      path: "showoverview",
      name: "Show Overview",
      component: () =>
        import("@/components/Pages/ReportsContainer/cinemaOverviewReport"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "RoleRoleManagement",
            "ProgrammingManager",
          ],
          false,
          "",
          201,
          1,
        ),
      },
    },
    {
      path: "show-details-report",
      name: "Show Details Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/showDetailsReport"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "RoleRoleManagement",
            "ProgrammingManager",
          ],
          false,
          "",
          310,
          1,
        ),
      },
    },
    {
      path: "daily-sales-report-v1",
      name: "Daily Sales Report V1",
      component: () =>
        import("@/components/Pages/ReportsContainer/dailySalesReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          95,
          1,
        ),
      },
    },

    //

    {
      path: "distributor-collection-report-v1",
      name: "Distributor Collection Report V1",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/distributorCollectionReport"
        ),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "RoleRoleManagement",
            "Distributor",
          ],
          false,
          "",
          98,
          1,
        ),
      },
    },

    // {
    //   path: 'distributor-share-report',
    //   name: 'Distributor Share Report',
    //   component: () => import('@/components/Pages/ReportsContainer/distributorShareReport'),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager', 'RoleRoleManagement'], false, '')
    //   }
    // },
    {
      path: "film-wise-collection-report-v1",
      name: "Film Collection Report V1",
      component: () =>
        import("@/components/Pages/ReportsContainer/filmWiseCollectionReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          96,
          1,
        ),
      },
    },

    {
      path: "performance-report-v1",
      name: "Performance Report V1",
      component: () =>
        import("@/components/Pages/ReportsContainer/performanceReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          94,
          1,
        ),
      },
    },
    {
      path: "performance-report",
      name: "Performance Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/performanceReportV2"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          94,
          1,
        ),
      },
    },
    {
      path: "performance-summary-report",
      name: "Performance And Summary Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/performanceAndSummaryReport"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          94,
          1,
        ),
      },
    },
    {
      path: "performance-summary-report-v4",
      name: "Performance And Summary Report Lebanon",
      component: () =>
        import("@/components/Pages/ReportsContainer/summaryAndPerformanceV4"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          94,
          1,
        ),
      },
    },
    {
      path: "performances-report-v3",
      name: "Performance Report V3",
      component: () =>
        import("@/components/Pages/ReportsContainer/performanceReportV2Akil"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          94,
          1,
        ),
      },
    },
    {
      path: "net-revenue-report",
      name: "Net Revenue Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/NetRevenueReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          263,
          1,
        ),
      },
    },
    {
      path: "loyalty-report",
      name: "Loyalty Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/LoyaltyReport"),

      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          367,
          1
        ),
      },
    },
    // {
    //   path: "gcam-report",
    //   name: "GCAM Report",
    //   component: () => import("@/components/Pages/ReportsContainer/GcamReport"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
    //       false,
    //       "",
    //       195,
    //       1
    //     )
    //   }
    // },
    {
      path: "gcam-report",
      name: "GCAM Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/GcamReport2"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          215,
          1,
        ),
      },
    },
    {
      path: "gcam-report-play",
      name: "GCAM Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/GcamReportTxSummary"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          215,
          1,
        ),
      },
    },
    {
      path: "Muncipality-report",
      name: "Muncipality Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/MuncipalityReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          273,
          1,
        ),
      },
    },
    {
      path: "mtax-report",
      name: "MTax Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/MTaxReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          215,
          1,
        ),
      },
    },
    {
      path: "box-office-report",
      name: "Box Office Summary Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/BoxOfficeSummary"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          216,
          1,
        ),
      },
    },
    {
      path: "box-office-report-lebanon",
      name: "Box Office Summary Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/BoxOfficeSummaryLebanon"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          216,
          1,
        ),
      },
    },
    {
      path: "rate-card-report",
      name: "Rate Card Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/RateCardReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          218,
          1,
        ),
      },
    },
    {
      path: "etransactions-report",
      name: "E-Transactions Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/etransactionsReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          221,
          1,
        ),
      },
    },
    {
      path: "refund-show-detail-report",
      name: "Refund Show Detail Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/RefundShowDetailReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          222,
          1,
        ),
      },
    },
    {
      path: "refund-fnb-report",
      name: "FnB Refund Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/fnbRefundReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          331,
          1,
        ),
      },
    },
    {
      path: "/budget-tracker/budget-tracker-page",
      name: "Budget Tracker",
      component: () =>
        import("@/components/Pages/ReportsContainer/budgetTracker"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          212,
          1,
        ),
      },
    },
    {
      path: "/budget-tracker/budget-tracker-report",
      name: "Budget Tracker Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/budgetTrackerReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          213,
          1,
        ),
      },
    },
    {
      path: "receipt-summary",
      name: "Receipt Summary",
      component: () =>
        import("@/components/Pages/ReportsContainer/boxOfficeReceiptReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          223,
          1,
        ),
      },
    },
    {
      path: "receipt-summary-lbp",
      name: "Receipt Summary Lbp",
      component: () =>
        import("@/components/Pages/ReportsContainer/boxOfficeReceiptReportLbp"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          223,
          1,
        ),
      },
    },
    {
      path: "receipt-summary-v2",
      name: "Receipt Summary",
      component: () =>
        import("@/components/Pages/ReportsContainer/boxOfficeReceiptReport_v3"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          223,
          1,
        ),
      },
    },

    {
      path: "box-office-receipt-report",
      name: "Box Office Receipt Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/boxOfficeReceiptReportAddOns"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          225,
          1,
        ),
      },
    },
    {
      path: "house-keeping-report",
      name: "House Keeping Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/houseKeepingReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          219,
          1,
        ),
      },
    },
    {
      path: "sales-logs",
      name: "Sales Logs",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          247,
          1,
        ),
      },
    },
    {
      path: "sales-register-report",
      name: "Sales Register Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReportNew"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-star",
      name: "Sales Register Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReportStar"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-wow",
      name: "Sales Register Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReportStar"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-cinepolis",
      name: "Sales Register Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReportStar"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-epix",
      name: "Sales Register Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesRegisterReportStar"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-beta",
      name: "Sales Register Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/salesRegisterReportNewBeta"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "sales-register-report-v1",
      name: "Sales Register Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/salesRegisterReportNewBetaOptimized"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          220,
          1,
        ),
      },
    },
    {
      path: "item-sales-register-report",
      name: "Sales Register Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/itemSalesRegisterReportSingleNew"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          246,
          1,
        ),
      },
    },
    {
      path: "item-sales-logs",
      name: "Item Logs",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/itemSalesRegisterReportSingle"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          248,
          1,
        ),
      },
    },
    {
      path: "online-bookings-report",
      name: "Online Bookings Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/onlineSalesReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          226,
          1,
        ),
      },
    },
    {
      path: "raw-material-supplier-wise-cost-report",
      name: "Raw Material Supplier Wise Cost Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/rawMaterialSupplierWiseReport"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          227,
          1,
        ),
      },
    },
    {
      path: "fnb-sales-report",
      name: "FnB Sales Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/fnbSalesReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          256,
          1,
        ),
      },
    },
    {
      path: "cashier-shift-close",
      name: "Cashier Shift Close",
      component: () =>
        import("@/components/Pages/ReportsContainer/revenueDropReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          249,
          1,
        ),
      },
    },
    {
      path: "materialized-report",
      name: "Materialized Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/materializedReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          250,
          1,
        ),
      },
    },
    {
      path: "distributor-report-star",
      name: "Distributor Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/distributorReportStar"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          259,
          1,
        ),
      },
    },
    {
      path: "municipality-report-detail",
      name: "Municipality Report Detail",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/muncipalityReportDetail.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          260,
          1,
        ),
      },
    },
    {
      path: "municipality-report-detail-with-complimentary",
      name: "Municipality Report Detail (With Complimentary)",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/muncipalityReportDetailWithComplimentary.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          260,
          1,
        ),
      },
    },
    {
      path: "municipality-report-summary",
      name: "Municipality Report Summary",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/municipalityReportSummary.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          261,
          1,
        ),
      },
    },

    {
      path: "dcr-finance-report",
      name: "DCR Finance Report",
      component: () => import("@/components/Pages/ReportsContainer/dcrFinance"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          266,
          1,
        ),
      },
    },
    {
      path: "maskewaari-report",
      name: "Maskewaari Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/MaskewaariReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          265,
          1,
        ),
      },
    },
    {
      path: "product-sales-report",
      name: "Product Sales Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/ProductSalesReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          267,
          1,
        ),
      },
    },
    {
      path: "month-day-wise-report",
      name: "DCR Finance Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/monthDayWiseTracker"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          291,
          1,
        ),
      },
    },
    {
      path: "screen-scheduling",
      name: "Screen Scheduling Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/screenScheduling"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          276,
          1,
        ),
      },
    },
    {
      path: "sales-book",
      name: "Sales Book",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesBookReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          251,
          1,
        ),
      },
    },
    {
      path: "sales-book-fix",
      name: "Sales Book Fix",
      component: () =>
        import("@/components/Pages/ReportsContainer/salesBookReportFix"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "sales-return-with-cancel-reason",
      name: "Sales Return With Cancel Reason",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/salesReturnWithCancelReason"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          252,
          1,
        ),
      },
    },
    {
      path: "voucher-useage-report",
      name: "Voucher Useage Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/voucherUseageReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          274,
          1,
        ),
      },
    },
    {
      path: "advance-fnb-report",
      name: "Advance FnB Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/advanceFnbOnline.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          275,
          1,
        ),
      },
    },
    {
      path: "e-wallet-report",
      name: "E-Wallet Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/ewalletReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          279,
          1,
        ),
      },
    },
    {
      path: "numero-report",
      name: "Numero Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/numeroReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          314,
          1,
        ),
      },
    },
    {
      path: "traffic-flow-analysis",
      name: "Traffic Flow Analysis",
      component: () =>
        import("@/components/Pages/ReportsContainer/trafficFlowAnalysis.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          317,
          1,
        ),
      },
    },
    {
      path: "month-and-daywise-report",
      name: "Month And Day Wise Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/monthAndDaywiseReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          291,
          1,
        ),
      },
    },
    {
      path: "offer-redemption-report",
      name: "Offer Redemption Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/offerRedemptionReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          290,
          1,
        ),
      },
    },
    {
      path: "dcr-performance-report",
      name: "Get DCR And Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/dcrAndPerformanceReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "empire-invoice-qr-logs",
      name: "E-Wallet Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/empireInvoiceQRLogs.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "transaction-summary-report",
      name: "Transaction Summary Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/transactionSummaryReportV2.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          287,
          1,
        ),
      },
    },
    {
      path: "transaction-summary-report-v2",
      name: "Transaction Summary Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/transactionSummaryReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          287,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report-qfx",
      name: "Summary Performance Report QFX",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportV5.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          214,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report",
      name: "Summary Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportAllClientV5.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          214,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report-platinum",
      name: "Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportPlatinum.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          214,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report-empire",
      name: "Summary Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportEmpireV5.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          214,
          1,
        ),
      },
    },
    {
      path: "transactions-refund-report",
      name: "Transaction Refund Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/transactionsRefundReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          27,
          1,
        ),
      },
    },
    {
      path: "summary-user-transaction-log-report",
      name: "Summary User Transaction Log Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryUserTransactionLogReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "user-cashier-summary-report",
      name: "User Cashier Summary  Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/userCashierSummaryReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          334,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report-epix",
      name: "Summary Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportEpixV5.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          214,
          1,
        ),
      },
    },
    {
      path: "summary-performance-report-epix-rent",
      name: "Summary Performance Rent Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/summaryAndPerformanceReportEpixV5.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          324,
          1,
        ),
      },
    },
    {
      path: "detailed-advanced-sales-report",
      name: "Detailed Advanced Sales Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/advancedDetailedSalesReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          286,
          1,
        ),
      },
    },
    {
      path: "cash-drawer-logs-report",
      name: "Cash Drawer - Manual Opening Logs",
      component: () =>
        import("@/components/Pages/ReportsContainer/cashDrawerLogs.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "detailed-prior-sales-report",
      name: "Detailed Prior Sales Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/detailedPriorSalesReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          285,
          1,
        ),
      },
    },
    {
      path: "electronic-payments-report",
      name: "Electronic Payments Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/electronicPaymentsReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          289,
          1,
        ),
      },
    },
    {
      path: "daily-cashup-report",
      name: "Daily Cashup Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/dailyCashupReportV2.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          292,
          1,
        ),
      },
    },
    {
      path: "cashier-session-reconcillation",
      name: "Cashier Session Reconcillation",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/CashierSessionReconcillation.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          292,
          1,
        ),
      },
    },
    // {
    //   path: "user-collection-report",
    //   name: "User Collection Report",
    //   component: () =>
    //     import(
    //       "@/components/Pages/ReportsContainer/userCollectionReport.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
    //       false,
    //       "",
    //       195,
    //       1
    //     ),
    //   },
    // },
    {
      path: "daily-operations-report",
      name: "Daily Operations Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/dailyOperationsReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          293,
          1,
        ),
      },
    },
    {
      path: "crm-transaction-data",
      name: "CRM Transaction Data",
      component: () =>
        import("@/components/Pages/ReportsContainer/crmTransactions.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "concession-item-sales",
      name: "Concession Item Sales",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/concessionItemSalesCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          253,
          1,
        ),
      },
    },
    {
      path: "concession-item-sales-trial",
      name: "Concession Item Sales",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/concessionItemSalesCategoryTrial"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "gcam-vat-detailed-report",
      name: "GCAM & Vat Detailed Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/GcamDetailedReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          255,
          1,
        ),
      },
    },
    {
      path: "cashier-revenue-report",
      name: "Cashier Revenue Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/rdrExceptionReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          217,
          1,
        ),
      },
    },
    {
      path: "cashier-shift-summary",
      name: "Cashier Shift Summary",
      component: () =>
        import("@/components/Pages/ReportsContainer/cashierShiftSummary"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          257,
          1,
        ),
      },
    },
    {
      path: "screenwise-occupancy-summary-report",
      name: "Screenwise Occupancy Summary Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/occupancySummaryReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          239,
          1,
        ),
      },
    },
    {
      path: "fnb-partner-sales-report",
      name: "F&B Delivery partner sales ",
      component: () =>
        import("@/components/Pages/ReportsContainer/fnbPartnerSalesReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          258,
          1,
        ),
      },
    },
    {
      path: "fnb-combo-sales-report",
      name: "FnB Combo Sales Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/fnbComboSales"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          224,
          1,
        ),
      },
    },
    {
      path: "screen-wise-collection-report-v1",
      name: "Screen Wise Collection Report V1",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/screenWiseCollectionReport"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          97,
          1,
        ),
      },
    },
    {
      path: "cinema-reports",
      name: "Cinema Reports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "screen-wise-collection-report",
          name: "Screen Wise Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/screenWiseCollectionReport-v2"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              97,
              1,
            ),
          },
        },

        {
          path: "distributor-collection-report",
          name: "Distributor Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorCollectionReportV2"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },

        {
          path: "distributor-collection-report-v3",
          name: "Distributor Collection Report",
          component: () =>
            // import(
            //   "@/components/Pages/ReportsContainer/distributorCollectionReport-akil"
            // ),
            import(
              "@/components/Pages/ReportsContainer/distributoCollectionReportV5"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-collection-report-v5-qfx",
          name: "Distributor Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributoCollectionReportV5QFX"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-collection-report-qfx-v2",
          name: "Distributor Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorCollectionReportQfxV2"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-share-summary-report",
          name: "Distributor Share Summary Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorShareSummaryReport"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              326,
              1,
            ),
          },
        },
        {
          path: "distributor-share-summary-week-wise-report",
          name: "Distributor Share Summary Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorShareSummaryWeekWiseReport"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              327,
              1,
            ),
          },
        },
        {
          path: "distributor-collection-report-lebanon",
          name: "Distributor Collection Report Lebanon",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryLebanon"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-summary",
          name: "Distributor Summary",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorCollectionSummarynewAkil"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              232,
              1,
            ),
          },
        },
        {
          path: "film-performance-taking-report",
          name: "Film Performance Taking Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/FilmPerformanceAndTakingReport"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              350,
              1,
            ),
          },
        },
        {
          path: "distributor-detailed-report",
          name: "Distributor Detailed Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummary"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              272,
              1,
            ),
          },
        },
        {
          path: "distributor-detailed-report-epix",
          name: "Distributor Detailed Report Epix",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryEpix"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
                "Distributor",
              ],
              false,
              "",
              272,
              1,
            ),
          },
        },
        {
          path: "distributor-report-cinepolis",
          name: "Distributor Report Cinepolis",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryOman"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              294,
              1,
            ),
          },
        },
        {
          path: "distributor-report-epix",
          name: "Distributor Report Epix",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryBahrain"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-report-platinum",
          name: "Distributor Detailed Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryPlatinum"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
        {
          path: "distributor-report-playcinemas",
          name: "Distributor Report Play",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/distributorDetailedCollectionSummaryPlayCinema"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              98,
              1,
            ),
          },
        },
      ],
    },
    {
      path: "daily-sales-reports",
      name: "Daily Sales Reports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "daily-sales-report",
          name: "Daily Sales Records",
          component: () =>
            import("@/components/Pages/ReportsContainer/dailySalesReport-v2"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              95,
              1,
            ),
          },
        },
        {
          path: "daily-sales-summary-report",
          name: "Daily_Sales_Records",
          component: () =>
            import("@/components/Pages/ReportsContainer/dailySalesReport-v3"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              95,
              1,
            ),
          },
        },
        {
          path: "daily-sales-summary-report-lebanon",
          name: "Daily_Sales_Records_Lebanon",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/dailySalesReportV3Lebanon"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              95,
              1,
            ),
          },
        },
        {
          path: "daily-sales-and-collection-report",
          name: "Daily Sales And Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/dailySalesAndCollectionStar"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              264,
              1,
            ),
          },
        },
        {
          path: "daily-sales-and-collection-report-epix",
          name: "Daily Sales And Collection Report New",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/dailySalesAndCollectionEpix"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              264,
              1,
            ),
          },
        },
        {
          path: "daily-sales-and-collection-report-play",
          name: "Daily Sales And Collection Report(PlayCinema)",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/dailySalesAndCollectionPlay"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              264,
              1,
            ),
          },
        },
        {
          path: "dailysalesreport",
          name: "Daily Sales Transaction Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/dailySalesReoprt_OLD_res-v2"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              95,
              1,
            ),
          },
        },
        {
          path: "daily-sales-report-v4",
          name: "Daily Sales Transaction Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/dailySalesReportV4"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              95,
              1,
            ),
          },
        },
        {
          path: "aggregator-daily-sales-report",
          name: "Aggregator Daily Sales Transaction Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/aggregatorsDailySalesReport"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              100,
              1,
            ),
          },
        },
      ],
    },
    {
      path: "movie-reports",
      name: "Movie Reports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "movie-analytics",
          name: "Movie Analytics",
          component: () =>
            import("@/components/Pages/ReportsContainer/MovieAnalytics"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              132,
              1,
            ),
          },
        },
        {
          path: "film-wise-collection-report",
          name: "Film Wise Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/filmWiseCollectionReport-v2"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              96,
              1,
            ),
          },
        },
        {
          path: "film-wise-collection-report-v2",
          name: "Film Wise Collection Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/filmWiseCollectionReportv2_new"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              96,
              1,
            ),
          },
        },
        {
          path: "aggregators-report",
          name: "Aggregators Reports",
          component: () =>
            import("@/components/Pages/ReportsContainer/aggregatorsReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              99,
              1,
            ),
          },
        },
        {
          path: "advance-booking-report",
          name: "Advance Booking Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/advanceBookingReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              108,
              1,
            ),
          },
        },
      ],
    },
    {
      path: "fnb-reports",
      name: "F&B Reports",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "fnb-analytics",
          name: "FnB Analytics",
          component: () =>
            import(
              "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbAnalytics"
            ),
          meta: {
            permissions:
              authenticationService.get("ENABLE_FNB") == "Y"
                ? getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    130,
                    1,
                  )
                : getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    130,
                    1,
                  ),
          },
        },
        {
          path: "fnb-category-analytics",
          name: "FnB Category Analytics",
          component: () =>
            import(
              "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbAnalyticsCategory"
            ),
          meta: {
            permissions:
              authenticationService.get("ENABLE_FNB") == "Y"
                ? getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    130,
                    1,
                  )
                : getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    130,
                    1,
                  ),
          },
        },
        {
          path: "fnb-transactions",
          name: "F&B Transactions",
          component: () =>
            import(
              "@/components/Pages/FoodAndBeveragesContainer/FnbtransactionComponents/FnbTransactions"
            ),
          meta: {
            permissions:
              authenticationService.get("ENABLE_FNB") == "Y"
                ? getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    162,
                    1,
                  )
                : getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    162,
                    1,
                  ),
          },
        },
        {
          path: "fnb-orders",
          name: "F&B App Orders",
          component: () =>
            import(
              "@/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/FnbOrders"
            ),
          meta: {
            permissions:
              authenticationService.get("ENABLE_FNB") == "Y"
                ? getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    163,
                    1,
                  )
                : getPermissions(
                    ["SuperAdmin", "CinemaManager", "HoManager"],
                    false,
                    "",
                    163,
                    1,
                  ),
          },
        },

        // {
        //   path: "recipe-report",
        //   name: "Recipe Report",
        //   component: () =>
        //     import("@/components/Pages/ReportsContainer/receipeReport"),
        //   meta: {
        //     permissions: getPermissions(
        //       [
        //         "SuperAdmin",
        //         "CinemaManager",
        //         "HoManager",
        //         "RoleRoleManagement"
        //       ],
        //       false,
        //       "",
        //       101,
        //       1
        //     )
        //   }
        // },
        {
          path: "recipe-report",
          name: "Recipe Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/receipeReportV2"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              101,
              1,
            ),
          },
        },
        {
          path: "fast-moving-report",
          name: "Fast Moving Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/fastMovingReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              102,
              1,
            ),
          },
        },
        {
          path: "concession-daily-report",
          name: "Concession Daily Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/concessionDailyReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              103,
              1,
            ),
          },
        },
        {
          path: "cogs-report",
          name: "COGS Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/cogsReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              104,
              1,
            ),
          },
        },
        {
          path: "cogs-report-v2",
          name: "COGS Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/cogsReportOptimized"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              104,
              1,
            ),
          },
        },
        {
          path: "food-cost-report",
          name: "COGS Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/foodCostReport.vue"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              300,
              1,
            ),
          },
        },
        {
          path: "monthly-food-cost-report",
          name: "COGS Report",
          component: () =>
            import(
              "@/components/Pages/ReportsContainer/MonthlyFoodCostReport.vue"
            ),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              355,
              1,
            ),
          },
        },
        {
          path: "stock-wastage-report",
          name: "Stock Wastage Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/stockWastageReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              105,
              1,
            ),
          },
        },

        {
          path: "current-stock-report",
          name: "Current Stock Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/currentStockReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              106,
              1,
            ),
          },
        },
        // {
        //   path: "current-stock-report-v2",
        //   name: "Current Stock Report-v2",
        //   component: () =>
        //     import("@/components/Pages/ReportsContainer/currentStockREport-v2"),
        //   meta: {
        //     permissions: getPermissions(
        //       [
        //         "SuperAdmin",
        //         "CinemaManager",
        //         "HoManager",
        //         "RoleRoleManagement"
        //       ],
        //       false,
        //       "",
        //       106,
        //       1
        //     )
        //   }
        // },
        {
          path: "municipality-report",
          name: "Payment Typeswise Sales Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/municipalityReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              107,
              1,
            ),
          },
        },
        {
          path: "expiry-report",
          name: "Expiry Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/ExpiryReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              137,
              1,
            ),
          },
        },
        {
          path: "add-ons-report",
          name: "Add Ons Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/AddOnsReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              177,
              1,
            ),
          },
        },
        {
          path: "customization-report",
          name: "Customization Report",
          component: () =>
            import("@/components/Pages/ReportsContainer/customizationReport"),
          meta: {
            permissions: getPermissions(
              [
                "SuperAdmin",
                "CinemaManager",
                "HoManager",
                "RoleRoleManagement",
              ],
              false,
              "",
              179,
              1,
            ),
          },
        },
      ],
    },
    // {
    //   path: "advance-sales-report",
    //   name: "Advance Sales Report",
    //   component: () =>
    //     import("@/components/Pages/ReportsContainer/advanceSalesReport"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
    //       false,
    //       "",
    //       133,
    //       1
    //     ),
    //   },
    // },
    // {
    //   path: "hourly-sph-report",
    //   name: "Hourly SPH Report",
    //   component: () =>
    //     import("@/components/Pages/ReportsContainer/hourlySphReport"),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
    //       false,
    //       "",
    //       134,
    //       1
    //     ),
    //   },
    // },
    {
      path: "print-tickets",
      name: "Print Tickets",
      component: () =>
        import("@/components/Pages/ReportsContainer/printTickets"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
        ),
      },
    },
    {
      path: "grn-report",
      name: "GRN Report",
      component: () => import("@/components/Pages/ReportsContainer/grnReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          136,
          1,
        ),
      },
    },

    {
      path: "daily-perishable-movement",
      name: "Daily Perishable Movement",
      component: () =>
        import("@/components/Pages/ReportsContainer/dailyPerishableMovement"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          178,
          1,
        ),
      },
    },

    {
      path: "transactions",
      name: "Transactions",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/transactionComponents/transactions.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          34,
          2,
        ),
      },
    },
    {
      path: "show-reservations",
      name: "Reservations",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/reservationComponents/showReservations.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          235,
          2,
        ),
      },
    },
    {
      path: "report-builder-fnb",
      name: "Report Builder FNB",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/reportBuilderComponents/reportBuilderComponentsFnB.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          231,
          2,
        ),
      },
    },

    {
      path: "unpaid-bookings",
      name: "Unpaid Bookings",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/UnpaidBookings/unpaidBookings.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          198,
          1,
        ),
      },
    },
    {
      path: "transaction-refund-report",
      name: "Transaction Refund Report",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/TransactionRefundComponents/viewTransactionRefunds"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          27,
          2,
        ),
      },
    },
    {
      path: "swap-transaction-refund-report",
      name: "Swap and Transaction Refund Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/swapAndRefundReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          240,
          2,
        ),
      },
    },
    {
      path: "swap-transaction",
      name: "Transaction Swap",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/TransactionSwap/viewSwapTransactions"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          185,
          2,
        ),
      },
    },
    {
      path: "list-of-pages",
      name: "List of Pages",
      component: () => import("@/components/Pages/listOfPages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          207,
          2,
        ),
      },
    },
    {
      path: "view-list-of-pages",
      name: "View List of Pages",
      component: () => import("@/components/Pages/viewListOfPages.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          208,
          2,
        ),
      },
    },
    {
      path: "get-macs-log",
      name: "Maccs Log",
      component: () =>
        import("@/components/Pages/ExhibitorManagement/Macs/macsLog.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          205,
          2,
        ),
      },
    },
    {
      path: "get-maccs-movie-list",
      name: "MACCS Movie List",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/Macs/maccs_movie_list.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          206,
          2,
        ),
      },
    },
    {
      path: "comscore-logs",
      name: "Comscore Log",
      component: () =>
        import("@/components/Pages/ExhibitorManagement/GCAM/gcamLogs.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          277,
          2,
        ),
      },
    },
    {
      path: "movie-pass-sales",
      name: "Movie Pass Sales Report",
      component: () =>
        import(
          "@/components/Pages/MarketingContainer/MoviePass/MoviePassSales.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          283,
          1,
        ),
      },
    },
    {
      path: "merchandise-transactions",
      name: "Merchandise Transactions",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/MechandiseComponents/MerchandiseTransactionReport"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          313,
          1,
        ),
      },
    },
    {
      path: "productSaleReport",
      name: "Product Sale Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/productSaleReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          288,
          2,
        ),
      },
    },
    {
      path: "movie-wise-summary-report",
      name: "Movie Wise Summary Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/movieWiseSummaryReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          34,
          2,
        ),
      },
    },
    {
      path: "staff-performance-report",
      name: "Staff Performance Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/staffPerformanceReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          302,
          1,
        ),
      },
    },
    {
      path: "fnb-sales-analysis-report",
      name: "Fnb Sales Analysis Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/fnbSalesAnalysis.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "get-offers-vouchers-consumption-summary-report",
      name: "Offers-Vouchers Consumption Summary Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/compsByItemsReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          341,
          1,
        ),
      },
    },
    // get-offers-vouchers-consumption-summary-report
    {
      path: "seat-classwise-sales-summary",
      name: "Class Wise Seat Summary Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/seatClassWiseSalesSummary.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "occupancy-analysis-report",
      name: "Occupancy Analysis Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/occupancyAnalysisReport"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          178,
          1,
        ),
      },
    },
    {
      path: "online-Offline-transactions-report",
      name: "Online & Offline Transaction Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/offlineOnlineTransactionReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          195,
          1,
        ),
      },
    },
    {
      path: "fab-offer-report",
      name: "FAB Offer Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/fabOfferReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          336,
          1,
        ),
      },
    },
    {
      path: "movie-wise-collection-report",
      name: "Movie Wise Collection Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/movieWiseCollectionReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          366,
          1
        ),
      },
    },
    {
      path: "week-wise-movie-history-report",
      name: "Week Wise Movie History Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/weekWiseMovieReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          340,
          1,
        ),
      },
    },
    {
      path: "movie-summary-report",
      name: "Consolidated Movie Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/movieSummaryReport.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          338,
          1,
        ),
      },
    },
    {
      path: "offline-online-revenue-report",
      name: "Offline Online revenue Report",
      component: () =>
        import(
          "@/components/Pages/ReportsContainer/offlineOnlineTotalRevenueReport.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "RoleRoleManagement"],
          false,
          "",
          338,
          1,
        ),
      },
    },
    {
      path: "movie-show-wise-report",
      name: "movie show wise Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/movieShowWiseReport"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "RoleRoleManagement",
            "ProgrammingManager",
          ],
          false,
          "",
          343,
          1,
        ),
      },
    },
    {
      path: "complimentary-report",
      name: "Complimentary Report",
      component: () =>
        import("@/components/Pages/ReportsContainer/complimentaryReport"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "CinemaManager",
            "HoManager",
            "RoleRoleManagement",
            "ProgrammingManager",
          ],
          false,
          "",
          349,
          1,
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/reportsRoutes.js